import React, { Component } from 'react';
import { Badge } from 'react-bootstrap';

class UsuarioStatus extends Component {
  render() {
    const { status } = this.props.data;

    let text = '...';
    let variant = 'info';

    switch (status) {
      case 1:
        text = 'Activo';
        variant = 'success';
        break;

      case 0:
        text = 'Suspendido';
        variant = 'danger';
        break;

      default:
        text = 'Desconocido';
        variant = 'secondary';
        break;
    }

    return <Badge variant={variant}>{text}</Badge>;
  }
}

export default UsuarioStatus;
